import { isPlatformServer } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Subscription } from 'rxjs';
import { SSOProviderEnum } from '../../../../../core/constants/auth.constant';
import { AuthService } from '../../../../../core/services/api/auth.service';
import { LoginService } from '../../../../../core/services/storage/login.service';

@Component({
    selector: 'app-profile-dropdown',
    standalone: false,
    templateUrl: './profile-dropdown.component.html',
    styleUrl: './profile-dropdown.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class ProfileDropdownComponent implements OnInit, OnDestroy {
    @Input() isMobile = false;
    @Input() isScrolled = false;

    protected isBrowser = false;
    protected isLoggedIn = false;
    protected isUserMenuOpen = false;
    protected providerType!: SSOProviderEnum;
    protected userName = '';

    protected readonly SSOProviderEnum = SSOProviderEnum;

    private subscriptions = new Subscription();

    constructor(
        @Inject(PLATFORM_ID) private platformID: object,
        private authService: AuthService,
        private loginService: LoginService,
        private msalService: MsalService,
    ) {}

    ngOnInit(): void {
        this.isBrowser = isPlatformServer(this.platformID);

        if (this.isBrowser) {
            return;
        }

        this.getData();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    onDropdownClick(event: MouseEvent): void {
        event.stopPropagation();
        this.closeUserMenu();
    }

    closeUserMenu(): void {
        this.isUserMenuOpen = false;
    }

    logOut(): void {
        this.authService.logout().subscribe({
            next: () => {
                if (this.loginService.getProviderType() === SSOProviderEnum.AzureAd) {
                    this.msalService.logoutRedirect({
                        postLogoutRedirectUri: '/home',
                    });
                }

                this.loginService.clear();
                window.location.href = '/home';
            },
        });
    }

    toggleUserMenu(): void {
        this.isUserMenuOpen = !this.isUserMenuOpen;
    }

    private getData(): void {
        this.isLoggedIn = !!(this.loginService.getAccessToken() && this.loginService.getRefreshToken());
        this.userName = this.loginService.getName();
        this.providerType = this.loginService.getProviderType();

        this.subscriptions.add(
            this.loginService.userName$.subscribe({
                next: (name) => {
                    this.userName = name;
                },
            }),
        );
    }
}
